import React from "react"

export const ConceptualGuideIcon = ({ width = 24, height = 24, ...rest }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
      <circle r="7.5" transform="matrix(-1 0 0 1 14.5 9.5)" />
      <path d="M17.7383 7.13138C17.0085 6.1422 15.8339 5.5 14.5086 5.5C12.2947 5.5 10.5 7.29087 10.5 9.5C10.5 11.7091 12.2947 13.5 14.5086 13.5C16.6 13.5 18.3165 11.9014 18.5 9.86208H15.1497" />
      <circle r="2.5" transform="matrix(1 0 0 -1 4.5 18.5)" />
      <line x1="0.75" y1="-0.75" x2="3.25" y2="-0.75" transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 6 16.5)" />
    </g>
  </svg>
)
